module.exports = __webpack_public_path__ + "alphavida.jpg?19040d537779df24a56cc8cdccc294e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/alphavida.jpg
// module id = 102
// module chunks = 0